import { Text } from "@ui-component-library";

const BallIcon = ({value}) => {
  const colors = {
    one: 'bg-[#059669]',
    two: 'bg-[#FBBF24]',
    three: 'bg-[#F97316]',
    four: 'bg-[#F87171]',
    sawtimber: 'bg-[#7C6ED9]',
    pulpwood: 'bg-[#3F8888]'
  }

  const bgColor = colors[value] || 'bg-gray-400';

  return <div className={`${bgColor} rounded-full w-[8px] h-[8px]`}></div>
}

export default function Tooltip({ active, payload, label }) {
  if (active && payload && payload.length) {
    return (
      <div className="flex flex-col bg-white rounded min-w-[160px] p-2" style={{boxShadow: '1px 1px 20px rgba(0, 0, 0, .2)'}}>
        <div className='flex justify-between'>
          <Text className='line-clamp-1' variant='text-xs/leading-normal/medium'>{payload[0].payload.label ? payload[0].payload.label : label}</Text>
          <Text className='text-[#737373] ml-2' variant='text-2xs/leading-none/medium'>kr/m³fub</Text>
        </div>

        <div className='flex h-[2px] w-full bg-[#E6E6E6] mt-2'></div>
        
        
        <div className='flex flex-col'>
          {payload[0].payload.all?.map(i => {
            if(i.price > 0) {
              return <div className='flex justify-between mt-1'>
                <div className='flex items-center'>
                  <BallIcon value={i.value} />
                  <Text className='ml-2' variant='text-xs/leading-normal/medium'>{i.label}</Text>
                </div>
                
                <Text variant='text-xs/leading-normal/medium'>{i.price.toLocaleString('sv-SE')}</Text>
              </div>
            }
          })}
        </div>
      </div>
    );
  } else {
    return null;
  }
}
